module.exports = __webpack_public_path__ + "static/media/give4forest-icon.a62563b9.svg";